import React, { useEffect } from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import '../styles/Forum.css';

const Forum = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="forum-page">
      <Container className="mt-5">
        <Row className="justify-content-center">
          <Col md={10}>
            <div className="d-flex justify-content-between align-items-center mb-4">
              {/* <Link to="/" className="btn forum-btn ">
                <i className="fas fa-arrow-left me-2"></i>
                Back to Home
              </Link> REMOVING THIS LINK SINCE IT IS REDUNDANT*/}
            </div>
            
            <Card className="forum-header mb-4">
              <Card.Body className="text-center">
                <h1>Skyline RP Forum</h1>
                <p className="lead">Join our community and start your roleplay journey</p>
              </Card.Body>
            </Card>

            <Card className="forum-section mb-4">
              <Card.Header className="bg-primary text-white">
                <h3 className="mb-0">Application Process</h3>
              </Card.Header>
              <Card.Body>
                <h4>How to Apply:</h4>
                <ol>
                  <li>Join our Discord</li>
                  <li>Read and understand our rules</li>
                  <li>Fill out the application form</li>
                  <li>Wait for staff review</li>
                  <li>Get started with your roleplay journey!</li>
                </ol>
                <Button 
                  variant="success" 
                  size="lg" 
                  className="mt-3"
                  as={Link}
                  to="/application"
                >
                  <i className="fas fa-external-link-alt me-2"></i>
                  Start Your Application
                </Button>
              </Card.Body>
            </Card>

            <Card className="forum-section mb-4">
              <Card.Header className="bg-dark text-white">
                <h3 className="mb-0">Community Guidelines</h3>
              </Card.Header>
              <Card.Body>
                <h4>Our Rules:</h4>
                <ul>
                  <li>Be respectful to all community members</li>
                  <li>No toxic behavior or harassment</li>
                  <li>Follow roleplay guidelines</li>
                  <li>No power gaming or meta gaming</li>
                  <li>Keep OOC (Out of Character) chat in designated channels</li>
                </ul>
              </Card.Body>
            </Card>

            <Card className="forum-section mb-4">
              <Card.Header className="bg-info text-white">
                <h3 className="mb-0">Server Information</h3>
              </Card.Header>
              <Card.Body>
                <h4>Our Servers:</h4>
                <div className="server-info">
                  <div className="server-card">
                    <div className="server-card-header">
                      <div className="server-icon">
                        <i className="fas fa-server"></i>
                      </div>
                      <div className="server-details">
                        <h5>Skyline RP</h5>
                        <p>Our main roleplay server packed with quality scenes.</p>
                      </div>
                    </div>
                    <div className="server-card-footer">
                      <a 
                        href="https://servers.fivem.net/servers/detail/xmgrmx"
                        target="_blank" 
                        rel="noopener noreferrer"
                        className="btn forum-btn server-link"
                      >
                        <i className="fas fa-external-link-alt me-2"></i>
                        View on FiveM
                      </a>
                      <span className="server-status">
                        <i className="fas fa-circle text-success me-1"></i>
                        Online
                      </span>
                    </div>
                  </div>
                </div>
              </Card.Body>
            </Card>

            <Card className="forum-section mb-4">
              <Card.Header className="bg-success text-white">
                <h3 className="mb-0">Departments</h3>
              </Card.Header>
              <Card.Body>
                <h4>Available Roles:</h4>
                <div className="departments-grid">
                  <div className="department-card">
                    <h5>Civilian</h5>
                    <p>Start your journey as a civilian and build your character's story from the ground up.</p>
                  </div>
                  <div className="department-card">
                    <h5>Law Enforcement</h5>
                    <p>Join our police force and maintain order in the city.</p>
                  </div>
                  <div className="department-card">
                    <h5>Fire & EMS</h5>
                    <p>Save lives and protect property as a first responder.</p>
                  </div>
                  {/* <div className="department-card">
                    <h5>Dispatch</h5>
                    <p>Coordinate emergency responses and manage communications.</p>
                  </div> */}
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Forum; 